module.exports = __webpack_public_path__ + "static/media/caret-down.534ebdd1.svg";